export default {
  meta: {
    title: '陪练记录',
    parentPath: 'BOT配置',
    breadcrumbs: ['BOT配置', '陪练记录'],
  },
};
